import router from '../router';
import { isLegacyConnected } from './legacy-connector';

function handleWindowMessage({ data, origin }) {
  if (origin !== window.parent.location.origin) {
    return;
  }
  const { message, type } = data;

  if ((type === 'route-changed' || type === 'init-route') && message.path) {
    router.push({ path: message.path }).catch((err) => {
      // Ignore the vuex err regarding  navigating to the page they are already on.
      if (
        err.name !== 'NavigationDuplicated' &&
        !err.message.includes('Avoided redundant navigation to current location')
      ) {
        // But print any other errors to the console
        console.error(err);
      }
    });
  }
}

function handleKeydown(event) {
  // Prevent inputs, textarea and contenteditable events from bubbling out of the next container
  // We may need to add additional rules for extra input elements as they're added
  if (
    ['INPUT', 'TEXTAREA'].includes(event.target.tagName) ||
    event.target.getAttribute('contenteditable') === 'true'
  ) {
    event.stopImmediatePropagation();
    return;
  }
  window.parent.document.dispatchEvent(new KeyboardEvent('next:keydown', event));
}

// Fire keyup event into parent app
function handleKeyup(event) {
  window.parent.document.dispatchEvent(new KeyboardEvent('next:keyup', event));
}

// Fire body click event into parent app
function handleClick(event) {
  // avoid links opening in the next frame.
  if (event.target.tagName === 'A') {
    // ensuring links get opened in a new tab;
    event.target.setAttribute('target', '_blank');
  }
  if (event.target !== document.querySelector('[data-app]')) {
    window.parent.document.body.dispatchEvent(new MouseEvent('next:click', event));
  }
}

// Re-fire click event from parent into next app
function handleTkoClick(event) {
  // fire event for Vuetify click outside
  document.querySelector('[data-app]').dispatchEvent(new MouseEvent('click', event));
}

export default (window, body) => {
  if (!isLegacyConnected()) {
    return () => {};
  }

  const events = [
    { name: 'message', el: window, eventHandler: handleWindowMessage },
    { name: 'keydown', el: body, eventHandler: handleKeydown },
    { name: 'keyup', el: body, eventHandler: handleKeyup },
    { name: 'click', el: body, eventHandler: handleClick },
    { name: 'tko:click', el: body, eventHandler: handleTkoClick },
  ];

  events.forEach(({ name, el, eventHandler }) => {
    el.addEventListener(name, eventHandler, false);
  });

  return () => {
    events.forEach(({ name, el, eventHandler }) => {
      el.removeEventListener(name, eventHandler, false);
    });
  };
};
